import axios from 'axios'

//Action Types

export const BUSINESS_LOGIN_START = 'BUSINESS_LOGIN_START'
export const BUSINESS_LOGIN_SUCCESS = 'BUSINESS_LOGIN_SUCCESS'
export const BUSINESS_LOGIN_FAILED = 'BUSINESS_LOGIN_FAILED'

export const VOLUNTEER_LOGIN_START = 'VOLUNTEER_LOGIN_START'
export const VOLUNTEER_LOGIN_SUCCESS = 'VOLUNTEER_LOGIN_SUCCESS'
export const VOLUNTEER_LOGIN_FAILED = 'VOLUNTEER_LOGIN_FAILED'

export const REGISTER_BUSINESS_START = 'REGISTER_BUSINESS_START'
export const REGISTER_BUSINESS_SUCCESS = 'REGISTER_BUSINESS_SUCCESS'
export const REGISTER_BUSINESS_FAILED = 'REGISTER_BUSINESS_FAILED'

export const REGISTER_VOLUNTEER_START = 'REGISTER_VOLUNTEER_START'
export const REGISTER_VOLUNTEER_SUCCESS = 'REGISTER_VOLUNTEER_SUCCESS'
export const REGISTER_VOLUNTEER_FAILED = 'REGISTER_VOLUNTEER_FAILED'

export const ADD_FOOD_START = 'ADD_FOOD_START'
export const ADD_FOOD_SUCCESS = 'ADD_FOOD_SUCCESS'
export const ADD_FOOD_FAILED = 'ADD_FOOD_FAILED'

export const GET_FOODITEMS_START = 'GET_FOODITEMS_START'
export const GET_FOODITEMS_SUCCESS = 'GET_FOODITEMS_SUCCESS'
export const GET_FOODITEMS_FAILED = 'GET_FOODITEMS_FAILED'

export const UPDATE_FOODITEM_START = 'UPDATE_FOODITEM_START'
export const UPDATE_FOODITEM_SUCCESS = 'UPDATE_FOODITEM_SUCCESS'
export const UPDATE_FOODITEM_FAILED = 'UPDATE_FOODITEM_FAILED'

export const DELETE_FOODITEM_START = 'DELETE_FOODITEM_START'
export const DELETE_FOODITEM_SUCCESS = 'DELETE_FOODITEM_SUCCESS'
export const DELETE_FOODITEM_FAILED = 'DELETE_FOODITEM_FAILED'

//Action Creators

// export function getAccount() {
//     return (dispatch) =>{
//         dispatch({type:FRIENDS_FETCHING})
//         const headers = {
//             Authorization: localStorage.getItem('token')
//         }
//         axios.get('http://localhost:5000/api/friends', { headers })
//         .then((res)=>{
//             dispatch({type:FRIENDS_FETCH_SUCCESS, payload:res.data})
//         })
//         .catch((err)=>{
//             dispatch({type:FRIENDS_FETCH_FAILED, payload:err.response.data})
//         })
//     }
// }

export function loginBusiness (username, password){
    return (dispatch) => {
        dispatch({type: BUSINESS_LOGIN_START})
        return axios.post('https://bw-replate.herokuapp.com/api/auth/business/login', { username, password })
        .then((res) => {
            const payload = res.data
            localStorage.setItem('token', res.data.token)
            console.log(res.data.token,'LOG IS HERE <---')
            dispatch({type: BUSINESS_LOGIN_SUCCESS, payload})
        })
        .catch((res) => {
            const payload = res.response ? res.response.data : res
            dispatch({type: BUSINESS_LOGIN_FAILED, payload})
            console.log(res,'LOG IS HERE <---')
        })
    }
}

export function loginVolunteer (username, password){
    return (dispatch) => {
        dispatch({type: VOLUNTEER_LOGIN_START})
        return axios.post('https://bw-replate.herokuapp.com/api/auth/volunteer/login', { username, password })
        .then((res) => {
            const payload = res.data
            localStorage.setItem('token', res.data.token)
            console.log(res.data,'LOG IS HERE <---')
            dispatch({type: VOLUNTEER_LOGIN_SUCCESS, payload})
        })
        .catch((err) => {
            const payload = err.response ? err.response.data : err
            dispatch({type: VOLUNTEER_LOGIN_FAILED, payload})
            console.log(err,'LOG IS HERE <---')
        })
    }
}

export function registerBusiness(username, password, organization_name, address, email, phone){
    return (dispatch) => {
        dispatch({type:REGISTER_BUSINESS_START})
        // const headers = {
        //     Authorization: localStorage.getItem('token')
        // }

        return axios.post('https://bw-replate.herokuapp.com/api/auth/business/register', { username, password, organization_name, address, email, phone }  )
        .then((res) => {
            dispatch({type:REGISTER_BUSINESS_SUCCESS, payload:res})
            console.log(res,'LOG IS HERE <---')
        })
        .catch((err) => {
            dispatch({type:REGISTER_BUSINESS_FAILED, payload:err})
            console.log(err)
        })
    }
}

export function registerVolunteer(username, password, organization_name, address, email, phone){
    return (dispatch) => {
        dispatch({type:REGISTER_VOLUNTEER_START})
        // const headers = {
        //     Authorization: localStorage.getItem('token')
        // }

        return axios.post('https://bw-replate.herokuapp.com/api/auth/volunteer/register', { username, password, organization_name, address, email, phone }  )
        .then((res) => {
            dispatch({type:REGISTER_VOLUNTEER_SUCCESS, payload:res})
        })
        .catch((err) => {
            dispatch({type:REGISTER_VOLUNTEER_FAILED, payload:err})
        })
    }
}

export function addFoodItem(name, time, description, is_claimed, pickup_date){
    return (dispatch) => {
        dispatch({type:ADD_FOOD_START})
        const headers = {Authorization: localStorage.getItem('token')}
        return axios.post('https://bw-replate.herokuapp.com/api/food', { name, time, description, is_claimed, pickup_date }, { headers })
        .then((res) => {
            dispatch({type:ADD_FOOD_SUCCESS, payload:res.data})
        })
        .catch((err) => {
            dispatch({type:ADD_FOOD_FAILED, payload:err})
        })
    }
}

export function getAllFoodItems(){
    return (dispatch) => {
        dispatch({type:GET_FOODITEMS_START})
        const headers = {
            Authorization: localStorage.getItem('token')
        }
        axios.get('https://bw-replate.herokuapp.com/api/food', { headers })
        .then((res) => {
            dispatch({type:GET_FOODITEMS_SUCCESS, payload:res.data})
        })
        .catch((err) => {
            dispatch({type:GET_FOODITEMS_FAILED, payload:err})
        })
    }
}

export function updateFoodItem(foodItem){
    return (dispatch) => {
        dispatch({type:UPDATE_FOODITEM_START})
        const headers = {
            Authorization: localStorage.getItem('token')
        }
        const id = dispatch.params.id
        return axios
        .put(`https://bw-replate.herokuapp.com/api/food/${id}`, foodItem, { headers })
        .then((res) => {
            dispatch({type:UPDATE_FOODITEM_SUCCESS, payload:res.data})
        })
        .catch((err) => {
            dispatch({type:UPDATE_FOODITEM_FAILED, payload:err})
        })
    }
}

export const deleteFoodItem = (id) => {
    return (dispatch) => {
        dispatch({type:DELETE_FOODITEM_START})
        const headers = {
            Authorization: localStorage.getItem('token')
        }
        return axios.delete(`https://bw-replate.herokuapp.com/api/food/${id}`, { headers })
        .then((res) => {
            console.log(res.data)
            dispatch({type:DELETE_FOODITEM_SUCCESS, payload:res.data})
        })
        .catch((err) => {
            dispatch({type:DELETE_FOODITEM_FAILED, payload:err})
        })
    }
}
